import { createContext } from 'react';

const MovmentContext = createContext({
    movment: 1,
    setMovment: () => {},
});

export default MovmentContext;
